module.exports = __webpack_public_path__ + "static/media/main-hero-image-v2.1e97b57d.jpg";